import { Navigate } from "react-router";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";
import useCaminoStore from "hooks/useCaminoStore";
import DashboardPage from "pages/Dashboard";

export default function Home() {
  const credentialType = useCaminoStore((state) => state.credentialType);

  if (credentialType === "personal_email") {
    return <Navigate to={SHARED_ROUTES.newHirePortal} replace />;
  }

  return <DashboardPage />;
}
